import request from './request.service';
import filterEmptyParams from 'utils/common/filterEmptyParams';
import asyncErrorHandler, { IErrorHandlerResponse } from 'utils/requests/errorHandler';

import { apiUrls } from 'constants/urls';

import { IdType } from 'types/common';
import { AccountListItemType } from 'types/accounts';
import { PaginatedParamsType, PaginatedRefactorType } from 'types/pagination';

export interface GetAccountsParams extends PaginatedParamsType {
  uid?: IdType;
  search?: string;
}

export type GetAccountsResponse = IErrorHandlerResponse<PaginatedRefactorType<AccountListItemType[]> | null>;

export const getAccounts = async ({ uid, search, page, per_page }: GetAccountsParams): Promise<GetAccountsResponse> => {
  const callback = async () => {
    return await request(apiUrls.accounts.all, {
      params: filterEmptyParams({ page, per_page, user_id: uid, search }),
    });
  };

  return await asyncErrorHandler(callback);
};

export interface GetAccountDetailsParams {
  aid?: IdType;
}

export type GetAccountDetailsResponse = IErrorHandlerResponse<AccountListItemType | null>;

export const getAccountDetails = async ({ aid }: GetAccountDetailsParams): Promise<GetAccountDetailsResponse> => {
  const callback = async () => {
    return await request(apiUrls.accounts.byId(aid));
  };

  return await asyncErrorHandler(callback);
};

export interface SearchAccountsParams extends PaginatedParamsType {
  search?: string;
  uid?: IdType;
}

export type SearchAccountsResponse = IErrorHandlerResponse<PaginatedRefactorType<AccountListItemType[]> | null>;

export const searchAccounts = async ({
  search,
  uid,
  page,
  per_page,
}: SearchAccountsParams): Promise<SearchAccountsResponse> => {
  const callback = async () => {
    return await request(apiUrls.accounts.search, {
      params: filterEmptyParams({ page, per_page, search, user_id: uid }),
    });
  };

  return await asyncErrorHandler(callback);
};

export interface UpdateAccountFeeParams {
  account_id: IdType;
  account_fee: number;
}

export type UpdateAccountFeeResponse = IErrorHandlerResponse<null>;

export const updateAccountFee = async ({
  account_id,
  account_fee,
}: UpdateAccountFeeParams): Promise<UpdateAccountFeeResponse> => {
  const callback = async () => {
    return await request(apiUrls.accounts.updateFee(account_id), {
      method: 'PUT',
      body: { account_fee_pps: account_fee, account_fee_pplns: account_fee },
    });
  };

  return await asyncErrorHandler(callback);
};
